import { render, staticRenderFns } from "./ot-contract-workflows.vue?vue&type=template&id=6a8e78ab&scoped=true&"
import script from "./ot-contract-workflows.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-workflows.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-workflows.vue?vue&type=style&index=0&id=6a8e78ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e78ab",
  null
  
)

export default component.exports